import Service from '@root/common/base/Service';
import { ServiceInterface } from '@root/common/types/service';

import { Weather } from '@root/modules/weather/typings/weather';
import getWeather from '@root/modules/weather/graphql/getWeather.graphql';

type ServiceVariables = Weather.FetchWeather['variables'];

export default class WeatherService extends Service implements ServiceInterface {
  public async fetch(variables: ServiceVariables) {
    const isHealthy = this.getHealthCheckStatus('weather-api');

    if (!isHealthy) {
      // return
    }

    if (variables.placeId && /,/.test(variables.placeId)) {
      const coords = variables.placeId.split(',');
      variables.placeId = undefined;
      variables.lat = coords[0];
      variables.lon = coords[1];
    }

    const apiProvider = this.createProvider('GraphQL');
    apiProvider
      .selectAPI('weather-api')
      .setLinkOptions({ useAutomaticPersistedQueries: true, useGETAutomaticPersistedQueries: true })
      .setCacheOptions({ key: `getWeather:${JSON.stringify(variables)}`, ttl: 30 })
      .enableCache(true);

    const options = Object.assign({ query: getWeather }, { variables });
    const response = await apiProvider.request<Weather.FetchWeather['data']>(options);

    return response.weather;
  }
}
